// test2043
(2043 && 0);
